import React from "react";
import { connect } from "react-redux";
import { isStringEmpty, doStringsMatch } from "lib/validate";

import { history } from "state/history";
import { getSchoolsLackingParentEmailAddresses, isParentsReady } from "state/school_money/selectors";
import { updateParentEmailAddress } from "state/school_money/actions";

import Overlay from "components/Overlay";
import Button from "components/Button";
import LoadingPage from "components/LoadingPage";

import eduspotLogo from "components/assets/images/eduspot-logo.svg";
import tickIcon from "components/assets/images/school_money/item-tick.svg";
import crossIcon from "components/assets/images/school_money/item-incorrect.svg";
import "./ParentEmailInputPage.css";

class ParentEmailInputPage extends React.Component {

  state = {
    isEmailValid: false,
    emailValue: "",
    confirmValue: ""
  }

  onEmailInputChange = event => {
    this.setState({
      emailValue: event.target.value,
      isEmailValid: event.target.validity.valid
    });
  }
  onConfirmInputChange = event => {
    this.setState({
      confirmValue: event.target.value
    });
  }

  onBackButtonClick = () => {
    history.push("/");
  }
  onContinueButtonClick = () => {
    if (this.isAllValid()) {
      this.props.updateParentEmailAddress(this.state.emailValue);
    }
  }

  doInputsMatch() {
    const { emailValue, confirmValue } = this.state;
    return doStringsMatch(emailValue, confirmValue);
  }

  isEmailValid() {
    const isEmpty = isStringEmpty(this.state.emailValue);
    const isValid = this.state.isEmailValid;
    return !isEmpty && isValid;
  }

  isConfirmValid() {
    return this.isEmailValid() && this.doInputsMatch();
  }

  isAllValid() {
    return this.isEmailValid() && this.doInputsMatch();
  }


  renderInputIndicator(isEmpty, isValid) {
    const showTick = isValid && !isEmpty;
    const showCross = !isValid && !isEmpty;
    return (
      <div className="parent-email-input-page__input-indicator">
        { showTick ? <img src={tickIcon} alt="valid" /> : null }
        { showCross ? <img src={crossIcon} alt="invalid" /> : null }
      </div>
    );
  }

  renderInputRow(value, isEmpty, isValid, label, onChange) {
    return (
      <div className="parent-email-input-page__input-row">
        <input className="parent-email-input-page__input" type="email" placeholder={label} value={value} onChange={onChange} />
        { this.renderInputIndicator(isEmpty, isValid) }
      </div>
    )
  }

  renderEmailInputRow() {
    const value = this.state.emailValue;
    const isEmpty = isStringEmpty(value);
    const isValid = this.isEmailValid();
    return this.renderInputRow(value, isEmpty, isValid, "Email address", this.onEmailInputChange);
  }

  renderConfirmInputRow() {
    const value = this.state.confirmValue;
    const isEmpty = isStringEmpty(value);
    const isValid = this.isConfirmValid();
    return this.renderInputRow(value, isEmpty, isValid, "Confirm email address", this.onConfirmInputChange);
  }

  renderPage() {
    return (
      <div className="parent-email-input-page__body">
        <img className="parent-email-input-page__logo" src={eduspotLogo} alt="Eduspot Logo" />
        <div className="parent-email-input-page__brand-text">eduspot</div>
        <div className="parent-email-input-page__blurb">
        <p>Welcome</p>
        <p>To begin making Payments and Bookings for your child, SchoolMoney requires your email address to send receipts.</p>
        </div>
        { this.renderEmailInputRow() }
        { this.renderConfirmInputRow() }
        <div className="parent-email-input-page__button-container">
          <Button className="parent-email-input-page__button" onClick={this.onBackButtonClick}>Back</Button>
          <Button className="parent-email-input-page__button parent-email-input-page__button--continue" onClick={this.onContinueButtonClick}>Continue</Button>
        </div>
      </div>
    )
  }

  render() {
    const cssModifier = this.isAllValid() ? "valid" : "invalid";
    return (
      <Overlay>
        <div className={`parent-email-input-page parent-email-input-page--${cssModifier}`}>
          { this.props.isReady ? this.renderPage() : <LoadingPage /> }
        </div>
      </Overlay>
    )
  }

}

export default connect(
  state => ({
    schools: getSchoolsLackingParentEmailAddresses(state),
    isReady: isParentsReady(state)
  }),
  { updateParentEmailAddress }
)(ParentEmailInputPage);



// WEBPACK FOOTER //
// ./src/components/school_money/ParentEmailInputPage.js